import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ConfirmedFilled = createSvgIcon(
  <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-.973-6.284L4.79 12.519l1.44-1.729 4.492 3.744 6.744-8.242 1.741 1.425-8.181 9.999Z" />,
  'ConfirmedFilled'
);

export { ConfirmedFilled };